import { TagsListProps } from "./TagsList.decl";
import { TagsListItem } from "./TagsListItem";

export function TagsList({ tags }: TagsListProps) {
  return (
    <div data-test="tags-list" className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <TagsListItem
          color={tag.color}
          name={tag.name}
          id={tag.id}
          key={tag.id}
        />
      ))}
    </div>
  );
}
